import React , {useState} from 'react';
import { Button, Form, Container, Row, Col, Card } from 'react-bootstrap';

import { auth, firestore } from "../config/db";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

import { Oval } from 'react-loader-spinner'
import { Link } from 'react-router-dom';



const Signup = () => {
  
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess ] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSignup = async (e) => {
    setLoading(true)
    e.preventDefault();
  
    // Validation logic
    if (!username.trim()) {
      setError("Email jest wymagany.");
      setLoading(false)
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(username)) {
      setError("Wprowadź poprawny adres email.");
      setLoading(false)
      return;
    }
    if (password.length < 8) {
      setError("Hasło musi mieć co najmniej 8 znaków.");
      setLoading(false)
      return;
    }
    if (password !== passwordRepeat) {
      setError("Hasła nie pasują do siebie.");
      setLoading(false)
      return;
    }
  
    setError(null);
  
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, username, password);
      const user = userCredential.user;
  
      // Add user to Firestore
      await setDoc(doc(firestore, "users", user.uid), {
        email: user.email,
        uid: user.uid,
        createdAt: new Date(),
        authenticated:false
      });
  
      console.log("User signed up and document added to Firestore.");
      setSuccess(true)
      setLoading(false)

    } catch (error) {
      console.error("Signup error:", error.message);
      if(error.message =="Firebase: Error (auth/email-already-in-use)."){
        setError("Konto już istnieje");
      }
      else{
        setError("Wystąpił błąd podczas rejestracji: " + error.message);
      }
      setLoading(false)

    }
    setLoading(false)
  };



  return (
    <Container className="h-screen flex justify-center items-center">
      <Row className="w-full justify-center">
        <Col  > 
          <Card className=" shadow-lg rounded-lg w-full">
            {
            (success === false)?
            <Card.Body>
              <h2 className="text-center text-xl mb-6">Rejestracja admina</h2>


              <Form onSubmit={handleSignup}>
                <Form.Group controlId="username " className='mb-2'>
                  <Form.Label className='text-black '>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Wprowadź email"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="border-2 border-gray-300 rounded-lg"
                  />
                </Form.Group>

                <Form.Group className="mb-2" controlId="password">
                  <Form.Label className='text-black'>Hasło</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Wprowadź hasło"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="border-2 border-gray-300 rounded-lg"
                  />
                </Form.Group>

                <Form.Group className="mb-2" controlId="password">
                  <Form.Label className='text-black'>Powtórz Hasło</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Wprowadź hasło"
                    value={passwordRepeat}
                    onChange={(e) => setPasswordRepeat(e.target.value)}
                    className="border-2 border-gray-300 rounded-lg"
                  />
                </Form.Group>
              {error && <p className="text-center mb-4 font-bold" style={{color:'red', fontWeight:'bold' }}>{error}</p>}
               
                <div className='w-full  flex items-center text-center mt-4'>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg"
                  >
                    {
                    loading? 
                    <div>
                      <Oval
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                        secondaryColor='#f5f5f5'
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    </div>
                    :
                    <div>Zarejestruj się</div>
                    }
                  </Button>
                </div>
              </Form>
            </Card.Body>

              :
              <Card.Body>
                <h2>Rejestracja pomyślna</h2>
                <div>W momencie gdy administrator zatwierdzi twoje konto, będziesz mógł się zalogować.</div>
                <Link to="/adminlogin" >Zaloguj</Link>
              </Card.Body>
            }
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Signup;

